import { OnboardingTooltip } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from '../CompareButton.css';
import { CompareFlightOnboardingContent } from './CompareFlightOnboardingContent';

export interface ICompareFlightButtonOnboardingProps extends React.PropsWithChildren {
  open: boolean;
  onClose(): void;
  onAboutComparisonClick(): void;
}

export function CompareFlightButtonOnboarding({
  children,
  open,
  onClose,
  onAboutComparisonClick,
}: ICompareFlightButtonOnboardingProps) {
  return (
    <OnboardingTooltip
      theme="black"
      content={<CompareFlightOnboardingContent onAboutComparisonClick={onAboutComparisonClick} />}
      placement="left-start"
      portal={false}
      open={open}
      onClose={onClose}
      flip={false}
    >
      <div className={styles['onboarding-anchor']}>{children}</div>
    </OnboardingTooltip>
  );
}
